import React,{useEffect, useState} from "react";
import { Box, useMediaQuery } from "@mui/material";
import HomeIcon from "../../assests/Images/home.svg";
import WebIcon from "../../assests/Images/web.svg";
import LogoIcon from "../../assests/Images/kangaroo.webp";
import SearchIcon from "../../assests/Images/list.svg";
import CaptchaGate from "../../components/common/CaptchaGate";

import { SidebarNav, MobileBottomNav } from "../../components/common/ChatNavigation.js";
import ChatPage from "../ChatPage/ChatPage.js";
import TurnstileGate from "../../components/common/Cloudfare.js";

const ChatBot = ({tester}) => {
    const isDesktop = useMediaQuery("(min-width:768px)"); // same breakpoint as before
  const [activeNav, setActiveNav] = useState(1);
  const [navlink, setNavlink] = useState(null);
  const [captchaVerified, setCaptchaVerified] = useState(
    sessionStorage.getItem("captchaVerified") === "true"
  );
  console.log("tester",tester)
  const bottomNavHeight = isDesktop ? 0 : 50;
  const icons = [WebIcon, LogoIcon, SearchIcon];
  const routes = [
    "https://www.shopperoo.us/",
    "/chatbot",
    "/shopping",
  ];


  useEffect(() => {
      if (!captchaVerified) return;
    }, [captchaVerified]);
  const setNavValue = (link) => {
    if(link)
    {
    console.log("link", link);

      routes[2] = link;   // update the 3rd route dynamically
      console.log("routes", routes);

    }
  };

  // if (!captchaVerified) {
  //     return (
  //       <CaptchaGate
  //         onSuccess={() => {
  //           setCaptchaVerified(true);
  //           sessionStorage.setItem("captchaVerified", "true");
  //         }}
  //       />
  //     );
  //   }


  return (
    <Box sx={{ display: "flex", height: "100%", bgcolor: "white" }}>
      {/* Desktop sidebar */}
      {/* {isDesktop && <SidebarNav icons={icons} activeNav={activeNav} setActiveNav={setActiveNav} routes={routes} />} */}

      {/* Main area */}
      <Box
        sx={{
          position: "relative",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <ChatPage isDesktop={isDesktop} link={setNavValue} tester={tester}/>

        {/* Mobile bottom nav (kept separated in Nav component) */}
        {/* {!isDesktop && (
          <MobileBottomNav
            icons={icons}
            activeNav={activeNav}
            setActiveNav={setActiveNav}
            bottomNavHeight={bottomNavHeight}
            routes={routes}
          />
        )} */}
      </Box>
    </Box>
  );
};

export default ChatBot;